import React, { useState, useCallback, useEffect } from "react";
import Dropdown from "../../../../common/element/Dropdown";
import Avatar from "../../../../common/element/Avatar";
import { Link, json } from "react-router-dom";
import classNames from "classnames";
import { motion } from "framer-motion";
import { HiChevronDown } from "react-icons/hi";
import LogoutUser from "../../../../common/snippet/logOut";
import * as userActions from "../../../../actions/index";
import { updateAvtarfunc } from "../../../../redux/classes/common/updateAvtar";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"
import useUnauthorizedHandler from "../../../../common/snippet/useUnauthorizedHandler";
const dropdownItemList = [];

export const UserDropdown = ({ className }) => {
  const ipAddress = useSelector((state) => state?.ipAddress?.ip);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { updateAvtar } = useSelector((state) => state);
  useEffect(() => {
    if (updateAvtar) {
      dispatch(updateAvtarfunc(false));
    }
  }, [updateAvtar]);
  const [RefreshUrl, SetRefreshUrl] = useState("/login")
  const logoutUser = () => {
    localStorage.removeItem("conserve_authtoken")
    localStorage.setItem("checkAuth", JSON.stringify(""));
    navigate(RefreshUrl)
  }


  const getLoginUserdta = JSON.parse(localStorage.getItem("LoginUserData"));
  let individualId;
  if (getLoginUserdta !== null) {
    individualId = getLoginUserdta?.userName?.individual_id;
  }

  const UserAvatar = (
    <div className={classNames(className, "flex items-center")}>
      <Avatar
        size={40}
        shape="circle"
        src={getLoginUserdta?.userName?.avatar}
        children={getLoginUserdta?.userName?.first_name?.slice(0, 1)}
      />
      <div className="ml-3">
        <div className="text-xs font-semibold text-gray-700">
        {`${getLoginUserdta?.userName?.first_name} ${getLoginUserdta?.userName?.last_name}`}
        </div>
        <div className="text-xs text-gray-600">
          {getLoginUserdta?.userName?.email}
        </div>
      </div>
      <motion.span className="ml-3 text-xl">
        <HiChevronDown />
      </motion.span>
    </div>
  );

  const GetAdminProfileById = useCallback(async () => {
    dispatch(userActions.GetAdminProfileById(individualId)).then(
      (response) => {
        if (response?.success === true) {
          const arrayData = response?.data;
          const updatedData = {
            ...getLoginUserdta,
            userName: {
              ...getLoginUserdta?.userName,
              avatar: arrayData?.avatar,
              first_name: arrayData?.first_name,
              last_name: arrayData?.last_name,
            },
          };
          dispatch(updateAvtarfunc(true));
          localStorage.setItem("LoginUserData", JSON.stringify(updatedData));
        } else if (response?.status === 401) {
          handleUnauthorizedAccess();
        } else {
        }
      }
    );

  }, [dispatch]);

  useEffect(() => {
    GetAdminProfileById();
  }, [individualId]);

  return (
    <>
      <Dropdown
        menuStyle={{ minWidth: 240 }}
        renderTitle={UserAvatar}
        placement="bottom-end p-2"
      >
        <Link className="flex gap-3 items-center" to="admin-setting">
          <Dropdown.Item className="flex gap-3">
            <span className="">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_17751_69467)">
                  <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61931 11.3807 7.50002 10 7.50002C8.61931 7.50002 7.50002 8.61931 7.50002 10C7.50002 11.3807 8.61931 12.5 10 12.5Z" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.6061 12.2727C15.5052 12.5012 15.4752 12.7547 15.5197 13.0005C15.5643 13.2462 15.6814 13.473 15.8561 13.6515L15.9015 13.697C16.0424 13.8377 16.1542 14.0048 16.2304 14.1887C16.3067 14.3727 16.3459 14.5698 16.3459 14.769C16.3459 14.9681 16.3067 15.1652 16.2304 15.3492C16.1542 15.5331 16.0424 15.7002 15.9015 15.8409C15.7608 15.9818 15.5937 16.0936 15.4098 16.1698C15.2258 16.2461 15.0287 16.2853 14.8296 16.2853C14.6305 16.2853 14.4333 16.2461 14.2494 16.1698C14.0654 16.0936 13.8983 15.9818 13.7576 15.8409L13.7121 15.7955C13.5336 15.6208 13.3068 15.5037 13.0611 15.4591C12.8153 15.4145 12.5619 15.4446 12.3334 15.5455C12.1093 15.6415 11.9182 15.801 11.7836 16.0042C11.649 16.2075 11.5768 16.4456 11.5758 16.6894V16.8182C11.5758 17.22 11.4161 17.6054 11.132 17.8896C10.8479 18.1737 10.4625 18.3334 10.0606 18.3334C9.65878 18.3334 9.2734 18.1737 8.98925 17.8896C8.70511 17.6054 8.54548 17.22 8.54548 16.8182V16.75C8.53961 16.4993 8.45844 16.2561 8.31253 16.0521C8.16661 15.8481 7.9627 15.6927 7.72729 15.6061C7.4988 15.5052 7.24533 15.4752 6.99957 15.5197C6.75382 15.5643 6.52705 15.6814 6.34851 15.8561L6.30305 15.9015C6.16233 16.0424 5.99523 16.1542 5.81129 16.2304C5.62736 16.3067 5.4302 16.3459 5.23108 16.3459C5.03197 16.3459 4.83481 16.3067 4.65087 16.2304C4.46693 16.1542 4.29983 16.0424 4.15911 15.9015C4.01824 15.7608 3.90648 15.5937 3.83023 15.4098C3.75398 15.2258 3.71474 15.0287 3.71474 14.8296C3.71474 14.6305 3.75398 14.4333 3.83023 14.2494C3.90648 14.0654 4.01824 13.8983 4.15911 13.7576L4.20457 13.7121C4.37922 13.5336 4.49637 13.3068 4.54093 13.0611C4.58549 12.8153 4.55541 12.5619 4.45457 12.3334C4.35853 12.1093 4.19908 11.9182 3.99583 11.7836C3.79258 11.649 3.5544 11.5768 3.31063 11.5758H3.18184C2.78 11.5758 2.39461 11.4161 2.11046 11.132C1.82632 10.8479 1.66669 10.4625 1.66669 10.0606C1.66669 9.65878 1.82632 9.2734 2.11046 8.98925C2.39461 8.70511 2.78 8.54548 3.18184 8.54548H3.25002C3.50077 8.53961 3.74396 8.45844 3.94797 8.31253C4.15199 8.16661 4.30738 7.9627 4.39396 7.72729C4.4948 7.4988 4.52489 7.24533 4.48033 6.99957C4.43577 6.75382 4.31861 6.52705 4.14396 6.34851L4.09851 6.30305C3.95763 6.16233 3.84588 5.99523 3.76963 5.81129C3.69338 5.62736 3.65413 5.4302 3.65413 5.23108C3.65413 5.03197 3.69338 4.83481 3.76963 4.65087C3.84588 4.46693 3.95763 4.29983 4.09851 4.15911C4.23922 4.01824 4.40633 3.90648 4.59026 3.83023C4.7742 3.75398 4.97136 3.71474 5.17048 3.71474C5.36959 3.71474 5.56675 3.75398 5.75069 3.83023C5.93462 3.90648 6.10173 4.01824 6.24244 4.15911L6.2879 4.20457C6.46644 4.37922 6.69321 4.49637 6.93897 4.54093C7.18472 4.58549 7.43819 4.55541 7.66669 4.45457H7.72729C7.95136 4.35853 8.14246 4.19908 8.27706 3.99583C8.41166 3.79258 8.4839 3.5544 8.48487 3.31063V3.18184C8.48487 2.78 8.6445 2.39461 8.92865 2.11046C9.21279 1.82632 9.59818 1.66669 10 1.66669C10.4019 1.66669 10.7872 1.82632 11.0714 2.11046C11.3555 2.39461 11.5152 2.78 11.5152 3.18184V3.25002C11.5161 3.4938 11.5884 3.73197 11.723 3.93522C11.8576 4.13847 12.0487 4.29793 12.2727 4.39396C12.5012 4.4948 12.7547 4.52489 13.0005 4.48033C13.2462 4.43577 13.473 4.31861 13.6515 4.14396L13.697 4.09851C13.8377 3.95763 14.0048 3.84588 14.1887 3.76963C14.3727 3.69338 14.5698 3.65413 14.769 3.65413C14.9681 3.65413 15.1652 3.69338 15.3492 3.76963C15.5331 3.84588 15.7002 3.95763 15.8409 4.09851C15.9818 4.23922 16.0936 4.40633 16.1698 4.59026C16.2461 4.7742 16.2853 4.97136 16.2853 5.17048C16.2853 5.36959 16.2461 5.56675 16.1698 5.75069C16.0936 5.93462 15.9818 6.10173 15.8409 6.24244L15.7955 6.2879C15.6208 6.46644 15.5037 6.69321 15.4591 6.93897C15.4145 7.18472 15.4446 7.43819 15.5455 7.66669V7.72729C15.6415 7.95136 15.801 8.14246 16.0042 8.27706C16.2075 8.41166 16.4456 8.4839 16.6894 8.48487H16.8182C17.22 8.48487 17.6054 8.6445 17.8896 8.92865C18.1737 9.21279 18.3334 9.59818 18.3334 10C18.3334 10.4019 18.1737 10.7872 17.8896 11.0714C17.6054 11.3555 17.22 11.5152 16.8182 11.5152H16.75C16.5062 11.5161 16.2681 11.5884 16.0648 11.723C15.8616 11.8576 15.7021 12.0487 15.6061 12.2727Z" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_17751_69467">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            <span className="text-xs text-gray-700 font-medium">Settings</span>
          </Dropdown.Item>
        </Link>
        <Dropdown.Item variant="divider" />
        <Link
          to="/login"
          onClick={(e) => {
            e.preventDefault(); // Prevent the default link behavior
            logoutUser(); // Call the logout function
          }}
        >
          <Dropdown.Item className="gap-3">
            <LogoutUser logOut={"dropdownLogout"} />
          </Dropdown.Item>
        </Link>
      </Dropdown>
    </>
  );
};

function mapStateToProps(state) {
  return {
    // loader: userActions.UserResetPasswordEmail.loader,
  };
}

const mapDispatchToProps = {
  onUpdateUser: userActions.UpdateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDropdown);
